import type { SearchFilterFacet } from '@jane/bloom/viewModels/productSearchFilters';

export function getFacetRange(facets: SearchFilterFacet[]) {
  const sorted = facets
    .filter(({ count }) => Number(count) > 0)
    .map((p) => parseFloat(p.value))
    .sort((a, b) => a - b);

  if (sorted.length < 1) {
    return {
      rangeMax: 100,
      rangeMin: 0,
    };
  }

  return {
    rangeMax: Math.min(100, Math.ceil(sorted[sorted.length - 1])),
    rangeMin: Math.floor(sorted[0]),
  };
}
